<template>
  <v-card class="mt-6">
    <v-card-title>
      Limite de consumo
    </v-card-title>
    <v-card-text>
      <v-row>
        <v-col>
          <v-switch
            :value="config.consumption_alert"
            color="primary"
            inset
            label="Ativar alerta de consumo"
            @change="updateField('consumption_alert', $event)"
          />
        </v-col>
        <v-col>
          <vuetify-money
            :value="config.consumption_max"
            :error="consumptionMaxInput.error"
            :error-messages="consumptionMaxInput.message"
            :disabled="!config.consumption_alert"
            outlined
            label="Cota máxima"
            @input="updateField('consumption_max', $event)"
          />
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: 'ConsumptionSettings',
  props: {
    config: {
      type: Object,
      required: true,
    },
    consumptionMaxInput: {
      type: Object,
      default: () => ({ error: false, message: '' }),
    },
  },
  methods: {
    updateField(field, value) {
      this.$emit('update', { [field]: value })
    },
  },
}
</script>
